// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/click.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ConversionStatus } from "./conversion_pb.js";
import { DateRange, Pagination, PaginationMeta } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.ClickClassification
 */
export enum ClickClassification {
  /**
   * @generated from enum value: CLICK_CLASSIFICATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLICK_CLASSIFICATION_HUMAN = 1;
   */
  HUMAN = 1,

  /**
   * @generated from enum value: CLICK_CLASSIFICATION_BOT = 2;
   */
  BOT = 2,

  /**
   * @generated from enum value: CLICK_CLASSIFICATION_UNKNOWN = 3;
   */
  UNKNOWN = 3,

  /**
   * @generated from enum value: CLICK_CLASSIFICATION_SUSPICIOUS = 4;
   */
  SUSPICIOUS = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ClickClassification)
proto3.util.setEnumType(ClickClassification, "tracker.v1.ClickClassification", [
  { no: 0, name: "CLICK_CLASSIFICATION_UNSPECIFIED" },
  { no: 1, name: "CLICK_CLASSIFICATION_HUMAN" },
  { no: 2, name: "CLICK_CLASSIFICATION_BOT" },
  { no: 3, name: "CLICK_CLASSIFICATION_UNKNOWN" },
  { no: 4, name: "CLICK_CLASSIFICATION_SUSPICIOUS" },
]);

/**
 * Click is a read-model row from ClickHouse `tracker.clicks`. Service is
 * query-only; writes happen inline in cmd/edge/.
 *
 * @generated from message tracker.v1.Click
 */
export class Click extends Message<Click> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string campaign_id = 3;
   */
  campaignId = "";

  /**
   * @generated from field: string traffic_source_id = 4;
   */
  trafficSourceId = "";

  /**
   * @generated from field: string flow_id = 5;
   */
  flowId = "";

  /**
   * @generated from field: string lander_id = 6;
   */
  landerId = "";

  /**
   * @generated from field: string offer_id = 7;
   */
  offerId = "";

  /**
   * @generated from field: string network_id = 8;
   */
  networkId = "";

  /**
   * @generated from field: string ts = 9;
   */
  ts = "";

  /**
   * @generated from field: string country = 10;
   */
  country = "";

  /**
   * @generated from field: string device = 11;
   */
  device = "";

  /**
   * @generated from field: string browser = 12;
   */
  browser = "";

  /**
   * @generated from field: string os = 13;
   */
  os = "";

  /**
   * @generated from field: string referer = 14;
   */
  referer = "";

  /**
   * The visitor's address, and the prefix it belongs to (/24 for v4, /48 for
   * v6). Replaces the former ip_hash, an unsalted sha256(ip)[:8] that could be
   * compared for equality and nothing else — never to a CIDR, which is the
   * only language every IP feed speaks. Empty when the click had no resolvable
   * address.
   *
   * @generated from field: string ip = 15;
   */
  ip = "";

  /**
   * @generated from field: string net = 30;
   */
  net = "";

  /**
   * @generated from field: string fbclid = 16;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 17;
   */
  gclid = "";

  /**
   * @generated from field: string clickid_external = 18;
   */
  clickidExternal = "";

  /**
   * sub1..sub20
   *
   * @generated from field: map<string, string> tracking_fields = 19;
   */
  trackingFields: { [key: string]: string } = {};

  /**
   * @generated from field: string page_served = 20;
   */
  pageServed = "";

  /**
   * @generated from field: bool bot_flag = 21;
   */
  botFlag = false;

  /**
   * @generated from field: tracker.v1.ClickClassification classification = 22;
   */
  classification = ClickClassification.UNSPECIFIED;

  /**
   * @generated from field: double bot_score = 23;
   */
  botScore = 0;

  /**
   * @generated from field: string user_agent = 24;
   */
  userAgent = "";

  /**
   * First-party visitor identity (vt_vid cookie) and whether this click was
   * that visitor's first.
   *
   * @generated from field: string visitor_id = 31;
   */
  visitorId = "";

  /**
   * @generated from field: bool is_unique = 32;
   */
  isUnique = false;

  /**
   * Geo beyond country. Present when the serving edge stamped visitor
   * location, or when the origin's IP-intel database resolved it.
   *
   * @generated from field: string region = 33;
   */
  region = "";

  /**
   * @generated from field: string city = 34;
   */
  city = "";

  /**
   * @generated from field: string referer_domain = 35;
   */
  refererDomain = "";

  /**
   * @generated from field: string ttclid = 36;
   */
  ttclid = "";

  /**
   * Traffic-source kind denormalized at write time (FACEBOOK_ADS, …).
   *
   * @generated from field: string source_kind = 37;
   */
  sourceKind = "";

  /**
   * @generated from field: string cost_amount = 38;
   */
  costAmount = "";

  /**
   * @generated from field: string cost_currency = 39;
   */
  costCurrency = "";

  /**
   * Flow node this click was resolved at.
   *
   * @generated from field: string node_id = 40;
   */
  nodeId = "";

  /**
   * @generated from field: string node_kind = 41;
   */
  nodeKind = "";

  /**
   * Meta match keys: the _fbp browser id minted at click time and the
   * dataset the click was served for. A CAPI event for this click carries
   * exactly these, so a click whose fbp/pixel are empty is a click that
   * cannot be matched.
   *
   * @generated from field: string fbp = 42;
   */
  fbp = "";

  /**
   * @generated from field: string pixel_id = 43;
   */
  pixelId = "";

  /**
   * Network the visitor was on. connection_type is the ASN type
   * (isp / hosting / business). isp falls back to the AS organisation the
   * edge records (as_org) when no ISP name is known.
   *
   * @generated from field: string isp = 44;
   */
  isp = "";

  /**
   * @generated from field: string asn = 45;
   */
  asn = "";

  /**
   * @generated from field: string connection_type = 46;
   */
  connectionType = "";

  /**
   * Browser's stated language preference (first Accept-Language entry).
   *
   * @generated from field: string language = 47;
   */
  language = "";

  /**
   * Ad-level creative id stamped by the traffic source.
   *
   * @generated from field: string creative_id = 48;
   */
  creativeId = "";

  /**
   * Opaque per-click bag the edge attached (base64url JSON).
   *
   * @generated from field: string additional_context = 50;
   */
  additionalContext = "";

  /**
   * human | verified_bot | meta_crawler | listed_ip | crawler | no_ua |
   * datacenter | bot_score — the edge's traffic class (decision 01: «Клики» = human).
   * Rows recorded before the class existed read human/bot from bot_flag.
   *
   * @generated from field: string traffic_class = 51;
   */
  trafficClass = "";

  /**
   * How many conversions (leads of any status, every goal) carry this click —
   * the clicks table's «Конв.»; filled by SearchClicks/GetClick.
   *
   * @generated from field: int64 conversions = 52;
   */
  conversions = protoInt64.zero;

  /**
   * Where those conversions stand, the best of them: approved over hold over
   * rejected over trash; UNSPECIFIED when the click has none (the card's
   * «Итог»). Filled with `conversions`.
   *
   * @generated from field: tracker.v1.ConversionStatus conversion_status = 53;
   */
  conversionStatus = ConversionStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<Click>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Click";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "traffic_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "flow_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "device", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "browser", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "os", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "referer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "net", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "clickid_external", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "tracking_fields", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 20, name: "page_served", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "bot_flag", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "classification", kind: "enum", T: proto3.getEnumType(ClickClassification) },
    { no: 23, name: "bot_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 24, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "visitor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "is_unique", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 33, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "referer_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "ttclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "source_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "cost_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "cost_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "node_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "fbp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "isp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "asn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "connection_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 47, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "creative_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 50, name: "additional_context", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "traffic_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 52, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 53, name: "conversion_status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Click {
    return new Click().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Click {
    return new Click().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Click {
    return new Click().fromJsonString(jsonString, options);
  }

  static equals(a: Click | PlainMessage<Click> | undefined, b: Click | PlainMessage<Click> | undefined): boolean {
    return proto3.util.equals(Click, a, b);
  }
}

/**
 * SignalContribution is one bot-scoring signal's contribution to the score —
 * the explainable breakdown behind the verdict.
 *
 * @generated from message tracker.v1.SignalContribution
 */
export class SignalContribution extends Message<SignalContribution> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  /**
   * Points the signal is worth when it fires. MAY BE NEGATIVE: some facts are
   * evidence of a human, so a reader must not filter on `weight > 0` — doing so
   * hides precisely the rows that explain why a click was let through.
   *
   * @generated from field: double weight = 3;
   */
  weight = 0;

  /**
   * @generated from field: double points = 4;
   */
  points = 0;

  /**
   * unavailable marks a signal whose input does not exist on this deployment —
   * not one that was checked and found clean. Renderers must distinguish the
   * two: "0 points because we looked and saw nothing" and "0 points because we
   * cannot look" are different facts about a verdict.
   *
   * @generated from field: bool unavailable = 5;
   */
  unavailable = false;

  /**
   * @generated from field: string reason = 6;
   */
  reason = "";

  constructor(data?: PartialMessage<SignalContribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SignalContribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "points", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignalContribution {
    return new SignalContribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignalContribution {
    return new SignalContribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignalContribution {
    return new SignalContribution().fromJsonString(jsonString, options);
  }

  static equals(a: SignalContribution | PlainMessage<SignalContribution> | undefined, b: SignalContribution | PlainMessage<SignalContribution> | undefined): boolean {
    return proto3.util.equals(SignalContribution, a, b);
  }
}

/**
 * TraceEdgeEval records why one candidate outgoing edge was taken or rejected.
 *
 * @generated from message tracker.v1.TraceEdgeEval
 */
export class TraceEdgeEval extends Message<TraceEdgeEval> {
  /**
   * @generated from field: string target_id = 1;
   */
  targetId = "";

  /**
   * @generated from field: string condition_id = 2;
   */
  conditionId = "";

  /**
   * @generated from field: bool matched = 3;
   */
  matched = false;

  /**
   * @generated from field: string reason = 4;
   */
  reason = "";

  constructor(data?: PartialMessage<TraceEdgeEval>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TraceEdgeEval";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "condition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "matched", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TraceEdgeEval {
    return new TraceEdgeEval().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TraceEdgeEval {
    return new TraceEdgeEval().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TraceEdgeEval {
    return new TraceEdgeEval().fromJsonString(jsonString, options);
  }

  static equals(a: TraceEdgeEval | PlainMessage<TraceEdgeEval> | undefined, b: TraceEdgeEval | PlainMessage<TraceEdgeEval> | undefined): boolean {
    return proto3.util.equals(TraceEdgeEval, a, b);
  }
}

/**
 * TraceStep is one node visit during the routing walk.
 *
 * @generated from message tracker.v1.TraceStep
 */
export class TraceStep extends Message<TraceStep> {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId = "";

  /**
   * @generated from field: string node_kind = 2;
   */
  nodeKind = "";

  /**
   * @generated from field: bool terminal = 3;
   */
  terminal = false;

  /**
   * @generated from field: repeated tracker.v1.TraceEdgeEval edge_evals = 4;
   */
  edgeEvals: TraceEdgeEval[] = [];

  /**
   * @generated from field: string took_edge = 5;
   */
  tookEdge = "";

  constructor(data?: PartialMessage<TraceStep>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TraceStep";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "node_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "terminal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "edge_evals", kind: "message", T: TraceEdgeEval, repeated: true },
    { no: 5, name: "took_edge", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TraceStep {
    return new TraceStep().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TraceStep {
    return new TraceStep().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TraceStep {
    return new TraceStep().fromJsonString(jsonString, options);
  }

  static equals(a: TraceStep | PlainMessage<TraceStep> | undefined, b: TraceStep | PlainMessage<TraceStep> | undefined): boolean {
    return proto3.util.equals(TraceStep, a, b);
  }
}

/**
 * ClickTrace is the full forensic record for a single click: the scoring
 * breakdown, the denormalised signal snapshot, and the node-by-node route.
 *
 * @generated from message tracker.v1.ClickTrace
 */
export class ClickTrace extends Message<ClickTrace> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  /**
   * @generated from field: string ts = 2;
   */
  ts = "";

  /**
   * @generated from field: double bot_score = 3;
   */
  botScore = 0;

  /**
   * @generated from field: tracker.v1.ClickClassification classification = 4;
   */
  classification = ClickClassification.UNSPECIFIED;

  /**
   * @generated from field: repeated tracker.v1.SignalContribution contributions = 5;
   */
  contributions: SignalContribution[] = [];

  /**
   * @generated from field: repeated tracker.v1.TraceStep steps = 6;
   */
  steps: TraceStep[] = [];

  /**
   * Signal snapshot.
   *
   * @generated from field: string ip_intel_kind = 7;
   */
  ipIntelKind = "";

  /**
   * @generated from field: double ip_intel_score = 8;
   */
  ipIntelScore = 0;

  /**
   * @generated from field: string ip_proxy_type = 9;
   */
  ipProxyType = "";

  /**
   * @generated from field: uint32 asn = 10;
   */
  asn = 0;

  /**
   * @generated from field: string asn_org = 11;
   */
  asnOrg = "";

  /**
   * @generated from field: string asn_type = 12;
   */
  asnType = "";

  /**
   * @generated from field: string country_iso2 = 13;
   */
  countryIso2 = "";

  /**
   * @generated from field: string tls_ja4 = 14;
   */
  tlsJa4 = "";

  /**
   * @generated from field: string ua_category = 15;
   */
  uaCategory = "";

  /**
   * @generated from field: bool ua_is_headless = 16;
   */
  uaIsHeadless = false;

  /**
   * @generated from field: double header_anomaly_score = 17;
   */
  headerAnomalyScore = 0;

  /**
   * @generated from field: string referrer_class = 18;
   */
  referrerClass = "";

  /**
   * @generated from field: double ip_click_rate_60s = 19;
   */
  ipClickRate60s = 0;

  /**
   * @generated from field: string route_terminal_kind = 20;
   */
  routeTerminalKind = "";

  /**
   * @generated from field: string route_terminal_id = 21;
   */
  routeTerminalId = "";

  constructor(data?: PartialMessage<ClickTrace>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClickTrace";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bot_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "classification", kind: "enum", T: proto3.getEnumType(ClickClassification) },
    { no: 5, name: "contributions", kind: "message", T: SignalContribution, repeated: true },
    { no: 6, name: "steps", kind: "message", T: TraceStep, repeated: true },
    { no: 7, name: "ip_intel_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ip_intel_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "ip_proxy_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "asn", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "asn_org", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "asn_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "country_iso2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "tls_ja4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "ua_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "ua_is_headless", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "header_anomaly_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 18, name: "referrer_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "ip_click_rate_60s", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 20, name: "route_terminal_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "route_terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickTrace {
    return new ClickTrace().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickTrace {
    return new ClickTrace().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickTrace {
    return new ClickTrace().fromJsonString(jsonString, options);
  }

  static equals(a: ClickTrace | PlainMessage<ClickTrace> | undefined, b: ClickTrace | PlainMessage<ClickTrace> | undefined): boolean {
    return proto3.util.equals(ClickTrace, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchClicksRequest
 */
export class SearchClicksRequest extends Message<SearchClicksRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: tracker.v1.DateRange range = 2;
   */
  range?: DateRange;

  /**
   * @generated from field: string campaign_id = 3;
   */
  campaignId = "";

  /**
   * @generated from field: string traffic_source_id = 4;
   */
  trafficSourceId = "";

  /**
   * @generated from field: string lander_id = 5;
   */
  landerId = "";

  /**
   * @generated from field: string offer_id = 6;
   */
  offerId = "";

  /**
   * @generated from field: string country = 7;
   */
  country = "";

  /**
   * @generated from field: tracker.v1.ClickClassification classification = 8;
   */
  classification = ClickClassification.UNSPECIFIED;

  /**
   * free text against click_id, fbclid, gclid, clickid_external, and ip when it parses as an address
   *
   * @generated from field: string search = 9;
   */
  search = "";

  /**
   * Only visits that are not a person (traffic class ≠ human) — the journal's
   * «Боты» tab. The same predicate every report uses (bot_flag = 1).
   *
   * @generated from field: bool bots_only = 10;
   */
  botsOnly = false;

  /**
   * One traffic class (see Click.traffic_class).
   *
   * @generated from field: string traffic_class = 11;
   */
  trafficClass = "";

  /**
   * Only visits that carry a conversion (any status, any goal) — the card's
   * «С лидом».
   *
   * @generated from field: bool with_conversions = 12;
   */
  withConversions = false;

  /**
   * Fill SearchClicksResponse.segments (the card's «Все · Люди · Боты · С
   * лидом» switch).
   *
   * @generated from field: bool with_segments = 13;
   */
  withSegments = false;

  /**
   * The visitor's city (Click.city), exact — the card's «Город».
   *
   * @generated from field: string city = 14;
   */
  city = "";

  constructor(data?: PartialMessage<SearchClicksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchClicksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "range", kind: "message", T: DateRange },
    { no: 3, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "traffic_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "classification", kind: "enum", T: proto3.getEnumType(ClickClassification) },
    { no: 9, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "bots_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "traffic_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "with_conversions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "with_segments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchClicksRequest {
    return new SearchClicksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchClicksRequest {
    return new SearchClicksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchClicksRequest {
    return new SearchClicksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchClicksRequest | PlainMessage<SearchClicksRequest> | undefined, b: SearchClicksRequest | PlainMessage<SearchClicksRequest> | undefined): boolean {
    return proto3.util.equals(SearchClicksRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchClicksResponse
 */
export class SearchClicksResponse extends Message<SearchClicksResponse> {
  /**
   * @generated from field: repeated tracker.v1.Click items = 1;
   */
  items: Click[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * Visits per traffic class under the same filters except traffic_class.
   * Filled only for bots_only (the tab's chips).
   *
   * @generated from field: repeated tracker.v1.ClickClassCount class_counts = 3;
   */
  classCounts: ClickClassCount[] = [];

  /**
   * The visits under the same filters without bots_only, traffic_class and
   * with_conversions, split the way the card's switch splits them. Filled
   * only for with_segments.
   *
   * @generated from field: tracker.v1.ClickSegments segments = 4;
   */
  segments?: ClickSegments;

  constructor(data?: PartialMessage<SearchClicksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchClicksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Click, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 3, name: "class_counts", kind: "message", T: ClickClassCount, repeated: true },
    { no: 4, name: "segments", kind: "message", T: ClickSegments },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchClicksResponse {
    return new SearchClicksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchClicksResponse {
    return new SearchClicksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchClicksResponse {
    return new SearchClicksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchClicksResponse | PlainMessage<SearchClicksResponse> | undefined, b: SearchClicksResponse | PlainMessage<SearchClicksResponse> | undefined): boolean {
    return proto3.util.equals(SearchClicksResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ClickSegments
 */
export class ClickSegments extends Message<ClickSegments> {
  /**
   * @generated from field: int64 visits = 1;
   */
  visits = protoInt64.zero;

  /**
   * traffic class human — the registry's «Клики».
   *
   * @generated from field: int64 people = 2;
   */
  people = protoInt64.zero;

  /**
   * bot_flag = 1 (bots_only).
   *
   * @generated from field: int64 bots = 3;
   */
  bots = protoInt64.zero;

  /**
   * Visits that carry a conversion (with_conversions).
   *
   * @generated from field: int64 with_conversions = 4;
   */
  withConversions = protoInt64.zero;

  constructor(data?: PartialMessage<ClickSegments>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClickSegments";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "people", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "bots", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "with_conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickSegments {
    return new ClickSegments().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickSegments {
    return new ClickSegments().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickSegments {
    return new ClickSegments().fromJsonString(jsonString, options);
  }

  static equals(a: ClickSegments | PlainMessage<ClickSegments> | undefined, b: ClickSegments | PlainMessage<ClickSegments> | undefined): boolean {
    return proto3.util.equals(ClickSegments, a, b);
  }
}

/**
 * @generated from message tracker.v1.ClickClassCount
 */
export class ClickClassCount extends Message<ClickClassCount> {
  /**
   * @generated from field: string traffic_class = 1;
   */
  trafficClass = "";

  /**
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  constructor(data?: PartialMessage<ClickClassCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClickClassCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickClassCount {
    return new ClickClassCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickClassCount {
    return new ClickClassCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickClassCount {
    return new ClickClassCount().fromJsonString(jsonString, options);
  }

  static equals(a: ClickClassCount | PlainMessage<ClickClassCount> | undefined, b: ClickClassCount | PlainMessage<ClickClassCount> | undefined): boolean {
    return proto3.util.equals(ClickClassCount, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickRequest
 */
export class GetClickRequest extends Message<GetClickRequest> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  constructor(data?: PartialMessage<GetClickRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickRequest {
    return new GetClickRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickRequest {
    return new GetClickRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickRequest {
    return new GetClickRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickRequest | PlainMessage<GetClickRequest> | undefined, b: GetClickRequest | PlainMessage<GetClickRequest> | undefined): boolean {
    return proto3.util.equals(GetClickRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickResponse
 */
export class GetClickResponse extends Message<GetClickResponse> {
  /**
   * @generated from field: tracker.v1.Click click = 1;
   */
  click?: Click;

  constructor(data?: PartialMessage<GetClickResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click", kind: "message", T: Click },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickResponse {
    return new GetClickResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickResponse {
    return new GetClickResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickResponse {
    return new GetClickResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickResponse | PlainMessage<GetClickResponse> | undefined, b: GetClickResponse | PlainMessage<GetClickResponse> | undefined): boolean {
    return proto3.util.equals(GetClickResponse, a, b);
  }
}

/**
 * One step of a click's journey (the click drawer's «Путь»), oldest first.
 *
 * @generated from message tracker.v1.ClickJourneyStep
 */
export class ClickJourneyStep extends Message<ClickJourneyStep> {
  /**
   * entry   — the click itself: the link opened, the node it routed to;
   * view    — a document shown (a lander, its step index, the branch served in);
   * cta     — a click on the lander's button;
   * offer   — the visitor sent on to an offer;
   * form    — the lead form posted on the lander (the edge's own lead event);
   * lead    — the conversion appeared (its first status);
   * status  — the conversion's status changed (a repeat of the same status
   *           is not a step).
   *
   * @generated from field: string kind = 1;
   */
  kind = "";

  /**
   * RFC3339
   *
   * @generated from field: string ts = 2;
   */
  ts = "";

  /**
   * @generated from field: string lander_id = 3;
   */
  landerId = "";

  /**
   * @generated from field: string offer_id = 4;
   */
  offerId = "";

  /**
   * @generated from field: string node_id = 5;
   */
  nodeId = "";

  /**
   * @generated from field: int32 step_index = 6;
   */
  stepIndex = 0;

  /**
   * @generated from field: string branch = 7;
   */
  branch = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 8;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * The payout in USD at the step (lead / status), "" when unknown.
   *
   * @generated from field: string payout_usd = 9;
   */
  payoutUsd = "";

  /**
   * @generated from field: string goal_key = 10;
   */
  goalKey = "";

  /**
   * @generated from field: string txid = 11;
   */
  txid = "";

  constructor(data?: PartialMessage<ClickJourneyStep>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClickJourneyStep";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "step_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 9, name: "payout_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "txid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickJourneyStep {
    return new ClickJourneyStep().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickJourneyStep {
    return new ClickJourneyStep().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickJourneyStep {
    return new ClickJourneyStep().fromJsonString(jsonString, options);
  }

  static equals(a: ClickJourneyStep | PlainMessage<ClickJourneyStep> | undefined, b: ClickJourneyStep | PlainMessage<ClickJourneyStep> | undefined): boolean {
    return proto3.util.equals(ClickJourneyStep, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickJourneyRequest
 */
export class GetClickJourneyRequest extends Message<GetClickJourneyRequest> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  constructor(data?: PartialMessage<GetClickJourneyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickJourneyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickJourneyRequest {
    return new GetClickJourneyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickJourneyRequest {
    return new GetClickJourneyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickJourneyRequest {
    return new GetClickJourneyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickJourneyRequest | PlainMessage<GetClickJourneyRequest> | undefined, b: GetClickJourneyRequest | PlainMessage<GetClickJourneyRequest> | undefined): boolean {
    return proto3.util.equals(GetClickJourneyRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickJourneyResponse
 */
export class GetClickJourneyResponse extends Message<GetClickJourneyResponse> {
  /**
   * @generated from field: repeated tracker.v1.ClickJourneyStep steps = 1;
   */
  steps: ClickJourneyStep[] = [];

  constructor(data?: PartialMessage<GetClickJourneyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickJourneyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "steps", kind: "message", T: ClickJourneyStep, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickJourneyResponse {
    return new GetClickJourneyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickJourneyResponse {
    return new GetClickJourneyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickJourneyResponse {
    return new GetClickJourneyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickJourneyResponse | PlainMessage<GetClickJourneyResponse> | undefined, b: GetClickJourneyResponse | PlainMessage<GetClickJourneyResponse> | undefined): boolean {
    return proto3.util.equals(GetClickJourneyResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickTraceRequest
 */
export class GetClickTraceRequest extends Message<GetClickTraceRequest> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  constructor(data?: PartialMessage<GetClickTraceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickTraceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickTraceRequest {
    return new GetClickTraceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickTraceRequest {
    return new GetClickTraceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickTraceRequest {
    return new GetClickTraceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickTraceRequest | PlainMessage<GetClickTraceRequest> | undefined, b: GetClickTraceRequest | PlainMessage<GetClickTraceRequest> | undefined): boolean {
    return proto3.util.equals(GetClickTraceRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickTraceResponse
 */
export class GetClickTraceResponse extends Message<GetClickTraceResponse> {
  /**
   * @generated from field: tracker.v1.ClickTrace trace = 1;
   */
  trace?: ClickTrace;

  constructor(data?: PartialMessage<GetClickTraceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickTraceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trace", kind: "message", T: ClickTrace },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickTraceResponse {
    return new GetClickTraceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickTraceResponse {
    return new GetClickTraceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickTraceResponse {
    return new GetClickTraceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickTraceResponse | PlainMessage<GetClickTraceResponse> | undefined, b: GetClickTraceResponse | PlainMessage<GetClickTraceResponse> | undefined): boolean {
    return proto3.util.equals(GetClickTraceResponse, a, b);
  }
}

